const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
let lastTime = -1;
let lastRandom: number[] = [];

function encodeTime(ms: number): string {
  let out = "";
  let t = ms;
  for (let i = 0; i < 10; i += 1) {
    out = ALPHABET[t % 32] + out;
    t = Math.floor(t / 32);
  }
  return out;
}

function randomDigits(): number[] {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (b) => b % 32);
}

function increment(digits: number[]): number[] {
  const next = [...digits];
  for (let i = next.length - 1; i >= 0; i -= 1) {
    if (next[i]! < 31) {
      next[i] = next[i]! + 1;
      return next;
    }
    next[i] = 0;
  }
  return randomDigits();
}

export function ulid(now = Date.now()): string {
  if (now <= lastTime) {
    lastRandom = increment(lastRandom);
    now = lastTime;
  } else {
    lastTime = now;
    lastRandom = randomDigits();
  }
  return encodeTime(now) + lastRandom.map((d) => ALPHABET[d]).join("");
}

export type IdPrefix =
  | "run_"
  | "cell_"
  | "exe_"
  | "stp_"
  | "asr_"
  | "flr_"
  | "evd_"
  | "art_"
  | "aga_"
  | "res_"
  | "fix_"
  | "snp_"
  | "evt_"
  | "req_"
  | "cmd_"
  | "chk_"
  | "aud_"
  | "rsl_"
  | "ins_"
  | "gen_"
  | "op_"
  | "idem_";

export function newId(prefix: IdPrefix): string {
  return prefix + ulid();
}

export function newCommandId(): string {
  return newId("cmd_");
}

export function newIdempotencyKey(): string {
  return newId("idem_");
}

export function ulidPart(id: string): string {
  const i = id.indexOf("_");
  return i < 0 ? id : id.slice(i + 1);
}

export function short12(id: string): string {
  return ulidPart(id).slice(-12).toLowerCase();
}

export function shortId(id: string): string {
  const i = id.indexOf("_");
  if (i < 0) return id;
  const body = id.slice(i + 1);
  if (body.length < 8) return id;
  return `${id.slice(0, i + 1)}${body.slice(0, 4)}…${body.slice(-2)}`;
}
